/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */
import { createApi } from "@reduxjs/toolkit/dist/query/react";

import Configuration from "common/types/Configuration";
import { transformResponse } from "common/util";
import { dynamicBaseQuery } from "store/api/utils/dynamicBaseQuery";

export const configurationApi = createApi({
    baseQuery: dynamicBaseQuery,
    reducerPath: "configurationApi",
    endpoints: (builder) => ({
        getConfiguration: builder.query<Configuration, { url: string }>({
            query: ({ url }) => ({ url }),
            transformResponse,
        }),
    }),
});

export const { useLazyGetConfigurationQuery } = configurationApi;
